import { TokenStorage } from "@/services/tokenStorage";

export const AuthorizedGuard = () => {
  if (TokenStorage.getToken() === null) {
    return { name: "login" };
  }
  return true;
};
